import { render } from "./RoleComponent.vue?vue&type=template&id=1f8bb95f&scoped=true"
import script from "./RoleComponent.vue?vue&type=script&lang=js"
export * from "./RoleComponent.vue?vue&type=script&lang=js"

import "./RoleComponent.vue?vue&type=style&index=0&id=1f8bb95f&scoped=true&lang=css"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8bb95f"]])

export default __exports__